<template>
  <div data-app>
    <v-divider></v-divider>

    <v-list
      subheader
      two-line
    >
      <v-subheader>{{ inputName }}</v-subheader>
      <v-list-item-group
        multiple
        active-class=""
        class="px-6"
      >
        <image-file-input-viewer
          class="mt-2"
          maxHeight="150"
          label="Section BG image"
          v-model="sectionData.bg_thumbnail"
          :clearable="true"
        />

        <v-checkbox
          label="Hide BG Image"
          v-show="sectionData.bg_thumbnail"
          v-model="sectionData.hide_bg_image"
        />
        <color-picker
          label="Section BG color"
          v-bind:color.sync="sectionData.bg_color"
        />

        <v-switch
          color="primary"
          label="Open links on new tab?"
          v-model="sectionData.is_new_tab"
        />
      </v-list-item-group>
    </v-list>

    <v-divider></v-divider>

    <v-list
      flat
      subheader
    >
      <v-subheader>Content</v-subheader>

      <v-list-item-group
        multiple
        active-class=""
        class="px-6"
      >
        <v-expansion-panels
          accordion
          class="mb-5"
        >
          <v-expansion-panel
            :key="i"
            v-for="(item, i) in sectionData[sectionData.type]"
            :class="{ 'section-has-error' : hasError(i)}"
          >
            <v-expansion-panel-header>{{ inputName }} {{ i + 1 }} </v-expansion-panel-header>
            <v-expansion-panel-content class="pb-4">
              <v-card
                class="withdrawal-options mb-5"
                shaped
              >
                <v-card-text>
                  <v-row>
                    <v-col
                      cols="12"
                      md="12"
                      class="px-5"
                    >
                      <v-text-field
                        v-model="sectionData[sectionData.type][i].title"
                        outlined
                        label="Feature Title"
                        dense
                        class="mt-5"
                      />

                      <normal-content-editor
                        v-model="sectionData[sectionData.type][i].description"
                        editorHeight="200"
                        label="Feature description"
                        :errorMessages="descriptionError(head(errorMessages['page_sections.'+ currIndex + '.' + sectionData.type + '.' + i + '.description' ]))"
                      />

                      <v-text-field
                        v-model="sectionData[sectionData.type][i].url"
                        outlined
                        label="Thumbnail URL"
                        class="mt-6"
                        :error-messages="head(errorMessages['page_sections.'+ currIndex + '.' + sectionData.type + '.' + i + '.url' ])"
                      />

                      <image-file-input-viewer
                        class="mt-6"
                        maxHeight="150"
                        label="Feature thumbnail"
                        v-model="sectionData[sectionData.type][i].thumbnail"
                        :errorMessages="imageError(head(errorMessages['page_sections.'+ currIndex + '.' + sectionData.type + '.' + i + '.thumbnail' ]))"
                        v-bind:updateThumbnail.sync="sectionData[sectionData.type][i].updating_thumbnail"
                      />

                      <image-file-input-viewer
                        maxHeight="150"
                        label="Feature mobile thumbnail"
                        v-model="sectionData[sectionData.type][i].thumbnail_mobile"
                      />

                      <label class="subtitle-1 pb-3 pt-1 mt-4">Alignment</label>

                      <!-- <v-switch
              label="LHS"
              v-model="sectionData[sectionData.type][i].thumbnail_props.lhs"
              @change="updateAlignmentData(i, 'lhs')"
            />

            <v-switch
              label="RHS"
              v-model="sectionData[sectionData.type][i].thumbnail_props.rhs"
              @change="updateAlignmentData(i, 'rhs')"
            /> -->
                      <v-radio-group
                        v-model="sectionData[sectionData.type][i].section_alignment"
                        row
                        @change="updateAlignmentData(i)"
                        mandatory
                      >
                        <v-radio
                          label="RHS"
                          value="rhs"
                        ></v-radio>
                        <v-radio
                          label="LHS"
                          value="lhs"
                        ></v-radio>
                      </v-radio-group>
                    </v-col>
                  </v-row>

                  <label class="subtitle-1 pb-3 pt-1 mt-4">Feature Title Properties</label>
                  <v-divider class="mt-2" />

                  <color-picker
                    class="mt-5"
                    label="Font color"
                    v-bind:color.sync="sectionData[sectionData.type][i].props[0].color"
                  />

                  <v-text-field
                    v-model="sectionData[sectionData.type][i].props[0].size"
                    outlined
                    label="Font Size(px)"
                    type="number"
                  />

                  <v-select
                    label="Font Weight"
                    v-model="sectionData[sectionData.type][i].props[0].style"
                    outlined
                    :items="txtWeightOptions"
                  />
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    @click="removeFAQ(i)"
                    color="red"
                    class="mr-3"
                    small
                    icon
                  >
                    <v-icon
                      small
                      color="red"
                    >mdi-trash-can-outline</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <v-btn
          v-if="sectionData[sectionData.type].length < 8"
          @click="addFAQ"
          class="green accent-4 white--text text-caption font-weight-bold header-btns"
        >Add Item
        </v-btn>
      </v-list-item-group>
    </v-list>
  </div>
</template>

<script>
import ImageFileInputViewer from '@/components/ImageFileInputViewer'
import NormalContentEditor from '@/components/NormalContentEditor'
import ColorPicker from '@/components/ColorPicker'
import has from 'lodash/has'
import head from 'lodash/head'

export default {
  name: 'PageFeature',
  data () {
    return {
      txtWeightOptions: [
        '300',
        '400',
        '500',
        '600'
      ]
    }
  },
  components: {
    ImageFileInputViewer,
    NormalContentEditor,
    ColorPicker
  },
  props: {
    sectionData: {
      type: Object,
      default () {
        return null
      }
    },
    inputName: {
      type: String,
      default: ''
    },
    errorMessages: {
      type: [String, Array, Object],
      default () {
        return null
      }
    },
    currIndex: {
      type: [String, Number],
      default: null
    },
    removedSections: {
      type: Array,
      default () {
        return []
      }
    }
  },
  methods: {
    head,
    addFAQ () {
      this.sectionData[this.sectionData.type].push(
        {
          title: null,
          description: null,
          thumbnail: null,
          thumbnail_mobile: null,
          thumbnail_props: {},
          updating_thumbnail: true,
          props: [
            {
              column_name: 'title',
              color: '#000000',
              size: null,
              style: null
            }
          ]
        }
      )
    },
    removeFAQ (i) {
      if (this.sectionData[this.sectionData.type][i].id) {
        this.removedSections.push({
          type: this.sectionData.type,
          id: this.sectionData[this.sectionData.type][i].id
        })
      }
      this.sectionData[this.sectionData.type].splice(i, 1)
    },
    setAlignmentData () {
      this.sectionData[this.sectionData.type].forEach((value, i) => {
        if (!value.thumbnail_props) {
          this.sectionData[this.sectionData.type][i].thumbnail_props = {
            lhs: false,
            rhs: true
          }
        }

        if (value.thumbnail && has(value.thumbnail, 'custom_properties')) {
          if (has(value.thumbnail.custom_properties, 'lhs')) {
            this.sectionData[this.sectionData.type][i].thumbnail_props.lhs = this.sectionData[this.sectionData.type][i].thumbnail.custom_properties.lhs
          }

          if (has(value.thumbnail.custom_properties, 'rhs')) {
            this.sectionData[this.sectionData.type][i].thumbnail_props.rhs = this.sectionData[this.sectionData.type][i].thumbnail.custom_properties.rhs
          }

          if (has(value.thumbnail.custom_properties, 'lhs') && this.sectionData[this.sectionData.type][i].thumbnail.custom_properties.lhs === true) {
            this.sectionData[this.sectionData.type][i].section_alignment = 'lhs'
          } else {
            this.sectionData[this.sectionData.type][i].section_alignment = 'rhs'
          }
        }
      })
    },
    updateAlignmentData (index) {
      let align = this.sectionData[this.sectionData.type][index].section_alignment

      if (align === 'lhs') {
        this.sectionData[this.sectionData.type][index].thumbnail_props.rhs = false
        this.sectionData[this.sectionData.type][index].thumbnail_props.lhs = true
        this.sectionData[this.sectionData.type][index].lhs = true
        this.sectionData[this.sectionData.type][index].rhs = false
      } else if (align === 'rhs') {
        this.sectionData[this.sectionData.type][index].thumbnail_props.lhs = false
        this.sectionData[this.sectionData.type][index].thumbnail_props.rhs = true
        this.sectionData[this.sectionData.type][index].rhs = true
        this.sectionData[this.sectionData.type][index].lhs = false
      }
    },
    descriptionError (errorString) {
      if (errorString) {
        return 'Feature description is required'
      } else {
        return null
      }
    },
    imageError (errorString) {
      if (errorString && errorString.includes('required')) {
        return 'Feature Image is required.'
      } else if (errorString && errorString.includes('must be an image')) {
        return 'Feature Image is must be an image.'
      } else {
        return errorString
      }
    },

    hasError (i) {
      return head(this.errorMessages['page_sections.' + this.currIndex + '.' + this.sectionData.type + '.' + i + '.description'])
    },

    checkIfThumbnailEmpty (thumbnail) {
      if (!thumbnail) {
        return 'Feature Image is required!'
      }
    }
  },
  created () {
    this.setAlignmentData()
  }

}
</script>

<style scoped>
.header-btns {
  color: #df4661;
  cursor: pointer;
}
.withdrawal-options {
  margin-top: 20px;
}

.section-has-error {
  border-color: var(--v-error-base) !important;
  border-width: 2px;
  border-style: solid;
}
</style>
